import { render, staticRenderFns } from "./TiposActividadGrid.vue?vue&type=template&id=21a8e2a6&"
import script from "./TiposActividadGrid.vue?vue&type=script&lang=ts&"
export * from "./TiposActividadGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports